import type { ElementType, ReactNode } from "react";

type TitleProps = {
  color?: string;
  children: ReactNode;
  as?: ElementType;
  fontSizeClass?: string;
  fontWeightClass?: string;
  colorClassGradient?: boolean;
  maxWidthClass?: string;
};

const CommonTitle = ({
  color = "#222222",
  children,
  as: Component = "h2",
  fontSizeClass = "text-[24px] lg:text-[32px]",
  fontWeightClass = "font-normal",
  colorClassGradient = false,
  maxWidthClass = "",
}: TitleProps) => {
  if (colorClassGradient) {
    return (
      <Component
        className={`bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent ${fontSizeClass} ${fontWeightClass} ${maxWidthClass}`}
      >
        {children}
      </Component>
    );
  }
  return (
    <Component
      style={{
        color: color,
      }}
      className={`${fontSizeClass} ${fontWeightClass} ${maxWidthClass}`}
    >
      {children}
    </Component>
  );
};

export default CommonTitle;
